import PackageProductEdit from './PackageProductEdit'
import PackageProductList from './PackageProductList'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: PackageProductList,
    edit: PackageProductEdit
}
